var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-box"},[_c('Table',{attrs:{"columns":_vm.columns10,"data":_vm.data9},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var row = ref.row;
return [_c('strong',[_vm._v(_vm._s(row.name))])]}},{key:"type",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.type))]}},{key:"content",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.content))]}},{key:"time",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.time))]}},{key:"status",fn:function(ref){
var row = ref.row;
return [(row.status === 0)?_c('span',{staticStyle:{"color":"#1890ff"}},[_vm._v("已通过")]):_vm._e(),(row.status === 1)?_c('span',{staticStyle:{"color":"#fe781d"}},[_vm._v("待审核")]):_vm._e(),(row.status === 2)?_c('span',{staticStyle:{"color":"#ff0000"}},[_vm._v("未通过")]):_vm._e(),(row.status === 3)?_c('span',{staticStyle:{"color":"#1890ff"}},[_vm._v("已通过")]):_vm._e()]}},{key:"edit",fn:function(ref){
var row = ref.row;
return [_c('span',{staticStyle:{"color":"#1890ff","cursor":"pointer"}},[_vm._v("删除")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }